module.exports = __webpack_public_path__ + "img/dicos.c51159bb.png";